<template>
  <section class="section--pd _pd-b0 _pt-md">
    <div class="inner Info__con">
      <div class="Info__head_area Info__head_area--tb_column">
        <h2 class="Head Head--cl01">
          <span class="Head__main Head--md">Information</span><br><span class="Head__main_jp">お知らせ</span>
        </h2>
      </div>
      <div
        v-if="isLogin"
        class="Info__inner w-100"
      >
        <div
          v-for="( item,key ) of listInformation"
          :key="key"
          class="Info__line"
        >
          <a
            class="Info__link"
            @click="readInfo(item.info)"
          >
            <span
              :class="(item.status_read ===0) ? 'Info__link--new' : ''"
            >
              {{ item.info.title }}
            </span>
          </a>
        </div>
        <div v-if="listInformation.length !== 0" class="Pagination__area Pagination__area--omit Pagination__area--fast">
          <a v-show="page > 1" class="Pagination__arrow Pagination__arrow__pre" @click="changePage(current_page - 1)" />
          <paginate
            v-model="page"
            :page-count="totalItem"
            :click-handler="clickCallback"
            :prev-text="''"
            :next-text="''"
            :container-class="'Pagination__num_box'"
            :page-class="'Pagination__num'"
            :active-class="'Pagination__num--selected'"
          />
          <a v-show="page < totalItem" class="Pagination__arrow Pagination__arrow__next" @click="changePage(current_page + 1)" />
        </div>
      </div>
      <div
        v-else
        class="Info__inner w-100"
      >
        <div
          v-for="( item,key ) of listInformation"
          :key="key"
          class="Info__line"
        >
          <a
            class="Info__link"
            @click="readInfo(item.id)"
          >
            <span>
              {{ item.title }}
            </span>
          </a>
        </div>
        <div v-if="listInformation.length !== 0" class="Pagination__area Pagination__area--omit Pagination__area--fast">
          <a v-show="page > 1" class="Pagination__arrow Pagination__arrow__pre" @click="changePage(current_page - 1)" />
          <paginate
            v-model="page"
            :page-count="totalItem"
            :click-handler="clickCallback"
            :prev-text="''"
            :next-text="''"
            :container-class="'Pagination__num_box'"
            :page-class="'Pagination__num'"
            :active-class="'Pagination__num--selected'"
          />
          <a v-show="page < totalItem" class="Pagination__arrow Pagination__arrow__next" @click="changePage(current_page + 1)" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import informatioService from '@/services/informationService'
import Paginate from 'vuejs-paginate'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'ListInformation',
  components: { Paginate },
  data() {
    return {
      listInformation: [],
      newInfo: 0,
      totalItem: 0,
      page: 1,
      current_page: 1
    }
  },
  computed: {
    ...mapState({
      isLogin: state => state.user.isLogin
    })
  },
  mounted() {
    this.getListInformation()
  },
  methods: {
    async getListInformation() {
      const date = new Date()
      const today = moment(date).format('YYYY/MM/DD HH:mm:ss')
      this.$store.dispatch('loading/updateLoading', true)
      const result = []
      let response = null
      if (this.isLogin) {
        response = await informatioService.infoUser()
        const listInfo = response.data.data
        listInfo.forEach(element => {
          const date_send = moment(element.info.date).format('YYYY/MM/DD HH:mm:ss')
          if (element.info !== null && element.info.noti_flag === 0 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
          if (element.info !== null && element.info.noti_flag === 1 && element.status_read === 1 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
      } else {
        response = await informatioService.index()
        const listInfo = response.data.data
        listInfo.forEach(element => {
          const date_send = moment(element.date).format('YYYY/MM/DD HH:mm:ss')
          if (Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
      }
      this.listInformation = result
      if (response.data.last_page > 10) {
        this.totalItem = 10
      } else {
        this.totalItem = response.data.last_page
      }
      this.current_page = response.data.current_page
      this.$store.dispatch('loading/updateLoading', false)
    },
    clickCallback(pageNum) {
      this.changePage(pageNum)
    },
    async changePage(pageNum) {
      const date = new Date()
      const today = moment(date).format('YYYY/MM/DD HH:mm:ss')
      this.$store.dispatch('loading/updateLoading', true)
      if (this.isLogin) {
        const response = await informatioService.paginateUser(pageNum)
        const listInfo = response.data.data
        const result = []
        listInfo.forEach(element => {
          const date_send = moment(element.info.date).format('YYYY/MM/DD HH:mm:ss')
          if (element.info !== null && element.info.noti_flag === 0 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
          if (element.info !== null && element.info.noti_flag === 1 && element.status_read === 1 && Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
        this.listInformation = result
        this.current_page = response.data.current_page
        this.page = pageNum
      } else {
        const response = await informatioService.paginate(pageNum)
        const listInfo = response.data.data
        const result = []
        listInfo.forEach(element => {
          const date_send = moment(element.date).format('YYYY/MM/DD HH:mm:ss')
          if (Date.parse(date_send) <= Date.parse(today)) {
            result.push(element)
          }
        })
        this.listInformation = result
        this.current_page = response.data.current_page
        this.page = pageNum
      }
      this.$store.dispatch('loading/updateLoading', false)
    },
    async readInfo(info) {
      if (this.isLogin) {
        this.$store.dispatch('loading/updateLoading', true)
        await informatioService.read(info.id)
        this.$store.dispatch('loading/updateLoading', false)
      }
      window.location.href = info.link
    }
  }
}
</script>
